
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import store from '../../../store';

const ContactDetailsControl = new Vue({
  store,
  computed: {
    ...mapGetters({
      getterContactData: 'contactDetails/contactData',
      getterCtrlPanelDisplayed: 'contactDetails/ctrlPanelDisplayedGet',
    }),
  },
  methods: {
    ...mapActions({
      storeContactDataFetch: 'contactDetails/contactDataFetch',
    }),
    ...mapMutations({
      storeCtrlPanelDisplayed: 'contactDetails/CTRL_PANEL_DISPLAYED_SET',
    }),
    // used by contact list - loads contact details from backend
    loadContactDetails(organisationId, contactId) {
      // load only if contact is not already active
      if (this.getterContactData.id !== contactId) {
        this.storeContactDataFetch({
          organisation_id: organisationId,
          contact_id: contactId,
        });
      }
    },
    displayPanel(isDisplayed) {
      this.storeCtrlPanelDisplayed(isDisplayed);
    },
    // should be used from inside component, emits events when contact data changes in UI
    emitContactDataChange(contactId, changedData) {
      this.$emit('change', { contactId, changedData });
    },
  },
});

export default ContactDetailsControl;